// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Spacer {\n  display: block;\n  width: 100%;\n}\n.Spacer--sm {\n  height: 32px;\n}\n.Spacer--md {\n  height: 48px;\n}\n.Spacer--lg {\n  height: 64px;\n}\n", ""]);
// Exports
module.exports = exports;
